module.exports = __webpack_public_path__ + "img/visualstudio.97e3627a.png";